import ConversationsChatCard from './ConversationsChatCard';
import RcsChatCard from './RcsChatCard';
import TF911ChatCard from './TF911ChatCard';

interface ChatCardDisplayProps {
  hasConversation: boolean;
  hasAccessToTF911: boolean;
  shouldRenderRcsChatCard: boolean;
}

/**
 * Handles all conditionals that would determine which chat card to display
 */
const ChatCardDisplay = ({
  hasConversation,
  hasAccessToTF911,
  shouldRenderRcsChatCard,
}: ChatCardDisplayProps) => {
  if (hasConversation) {
    return <ConversationsChatCard />;
  }

  if (hasAccessToTF911) {
    if (shouldRenderRcsChatCard) {
      return <RcsChatCard />;
    } else {
      return <TF911ChatCard />;
    }
  }

  return null;
};

export default ChatCardDisplay;
